import { initializeApp } from 'firebase/app';
import { getAuth, signInWithEmailAndPassword, createUserWithEmailAndPassword, signOut } from 'firebase/auth';
import type { User } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions'; // Import Functions SDK

// Configuration Firebase pour le projet stepburger-38206
const firebaseConfig = {
  apiKey: "AIzaSyB5aoIZDfu6REg4XwRN7qe0uz1O2AXqUG0",
  authDomain: "stepburger-38206.firebaseapp.com",
  projectId: "stepburger-38206",
  storageBucket: "stepburger-38206.firebasestorage.app",
  messagingSenderId: "387308288217",
  appId: "1:387308288217:web:b4b056246c52661386a6c8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app, 'europe-west1'); // Initialize Functions, specify region

// Service d'authentification
export const authService = {
  // Connexion avec email/password
  login: async (email: string, password: string) => {
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      return userCredential.user;
    } catch (error: any) {
      throw new Error(error.message);
    }
  },

  // Inscription (à utiliser pour créer des administrateurs)
  register: async (email: string, password: string) => {
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      return userCredential.user;
    } catch (error: any) {
      throw new Error(error.message);
    }
  },

  // Déconnexion
  logout: async () => {
    try {
      await signOut(auth);
      return true;
    } catch (error: any) {
      throw new Error(error.message);
    }
  },

  // Obtenir l'utilisateur courant
  getCurrentUser: (): User | null => {
    return auth.currentUser;
  }
};

export { auth, db, storage, functions }; // Export functions
export default app;
